import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/mp3/ding.mp3';
const _hoisted_1 = {
  class: "overlay"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock(_Fragment, null, [_cache[0] || (_cache[0] = _createElementVNode("div", {
    id: "recorder"
  }, null, -1)), _cache[1] || (_cache[1] = _createElementVNode("audio", {
    style: {
      "display": "none"
    },
    preload: "none",
    id: "ding_audio"
  }, [_createElementVNode("source", {
    src: _imports_0,
    type: "audio/mpeg"
  })], -1)), _withDirectives(_createElementVNode("div", _hoisted_1, null, 512), [[_vShow, $setup.overlay]])], 64);
}